@if (error && derrors) {
  <info [option]="optionInfo1">
    {{ error.message }}
  </info>
}
<info [option]="optionInfo2">
  Un justificatif de vos fonds devra obligatoirement être fourni en fin de
  souscription.
</info>
<funds-initial-payment
  [formGroup]="form"
  formArrayName="fundsOriginList"
  [derrors]="derrors"
></funds-initial-payment>
